import { render, staticRenderFns } from "./IndexNine.vue?vue&type=template&id=3d171034&"
import script from "./IndexNine.vue?vue&type=script&lang=js&"
export * from "./IndexNine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports